<div class="pagecontent">
    <div class="headercontent">
        <div class="header1">
            <span>Request Type</span>
        </div>
        <h1 class="header2">{{tripType}}-Trip Reimbursement Request</h1>
    </div>
    <div formGroupName="tripRequest">
        @for (date of appointmentDatesFr.controls; track date; let i = $index) {
        <div formArrayName="tripAppointments">   
            <div [formGroupName] ="i">
                <div class="appointment-date-container">
                    <div class="appointment-date-row">
                        <div class="form-field">
                            <label [for]="'appointmentDate'+i"> Appointment Date <span class="star">*</span></label>
                            <mat-form-field [class.datepicker-toggle]="tripRequest.get('isAcceptedPreTrip')?.value">
                                <input  [id]="'appointmentDate'+i" matInput [matDatepicker]="datepicker" formControlName="appointmentDate"
                                    placeholder="Choose a date"  [max]="maxDate" [min]="minDate" [errorStateMatcher]="matcher" readonly class="no-global"/>
                                <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                                <mat-datepicker #datepicker></mat-datepicker>
                                @if (hasError(`tripAppointments.${i}.appointmentDate`, 'invalid')) {
                                    <mat-error>Invalid Date.</mat-error>
                                }@else if (hasError(`tripAppointments.${i}.appointmentDate`, 'required')) {
                                    <mat-error>This field is required.</mat-error>
                                }@else if(hasError(`tripAppointments.${i}.appointmentDate`, 'pastDateRequired')) {
                                    <mat-error>Date should not be future date.</mat-error>
                                }@else if(hasError(`tripAppointments.${i}.appointmentDate`, 'futureDateRequired')) {
                                    <mat-error>Date should not be past date.</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="form-field">
                            <label [for]="'appointmentDateTime'+i"> Appointment Time <span class="star">*</span> </label>
                            <mat-form-field [class.timepicker-toggle]="tripRequest.get('isAcceptedPreTrip')?.value">
                                @if(!tripRequest.get('isAcceptedPreTrip')?.value) {
                                    <input [id]="'appointmentDateTime'+i" matInput [matTimepicker]="timepicker" formControlName="appointmentTime"
                                        placeholder="Choose a time" [errorStateMatcher]="matcher"/>
                                }
                                @else {
                                    <input [id]="'appointmentDateTime'+i" matInput [value]="date.get('appointmentTime')?.value | date:'shortTime'"
                                        placeholder="Choose a time" [errorStateMatcher]="matcher" readonly class="no-global" />
                                }
                                <mat-timepicker-toggle matIconSuffix [for]="timepicker"></mat-timepicker-toggle>
                                <mat-timepicker #timepicker></mat-timepicker>
                                @if (hasError(`tripAppointments.${i}.appointmentTime`, 'required')) {
                                    <mat-error>This field is required.</mat-error>
                                }
                                @if (hasError(`tripAppointments.${i}.appointmentTime`, 'timeRequired')) {
                                    <mat-error>Invalid Time.</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                     @if(!tripRequest.get('isAcceptedPreTrip')?.value)  {
                        <div class="remove-appointment">
                            <button class="button" (click)="removeAppointment(i)">Remove Appointment</button>
                        </div>
                    }
                </div>
            </div>
        </div>
        }
    </div>
    @if(!tripRequest.get('isAcceptedPreTrip')?.value) {
        <div class="add-appointment">
            <a tabindex="0" role="button" (click)="addAppointment()">
                <span>Add Appointment</span>
                <span>
                    <mat-icon aria-hidden="false" aria-label="Add action icon">add_circle_outline</mat-icon>
                </span>
            </a>
        </div>
    }
</div>